import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import Cookies from "js-cookie";

export default function SupportCancelOfferButton({ loanType, offer, onCancelled }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!offer?.can_cancel) return null;

  const cancelOffer = async () => {
    setBusy(true);
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/loans/${loanType}/offers/${offer.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${Cookies.get("support_token")}`,
            Accept: "application/json",
          },
        }
      );
      const json = await response.json();
      if (!response.ok) {
        throw new Error(json?.message || "Unable to cancel offer.");
      }
      setConfirming(false);
      message.success(json?.message || "Offer cancelled.");
      await onCancelled();
    } catch (error) {
      message.error(error.message || "Unable to cancel offer.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button danger onClick={() => setConfirming(true)} style={{ borderRadius: 10, fontWeight: 800 }}>
        Cancel offer
      </Button>
      <Modal
        title="Cancel this offer?"
        open={confirming}
        onCancel={() => !busy && setConfirming(false)}
        onOk={cancelOffer}
        okText="Cancel offer"
        cancelText="Keep offer"
        okButtonProps={{ danger: true }}
        confirmLoading={busy}
        cancelButtonProps={{ disabled: busy }}
        closable={!busy}
        maskClosable={!busy}
        keyboard={!busy}
      >
        <p>
          This will remove the offer from {offer.lender?.name || "this lender"} from
          both the borrower and lender dashboards. This action cannot be undone.
        </p>
        <p>Offers can only be cancelled before both sides have confirmed the loan.</p>
      </Modal>
    </>
  );
}
